import React from 'react'

export default function PageNotFount() {
    return (
        <div>
            <h2>Page Not found</h2>
        </div>
    )
}
